import { makeStyles } from '@material-ui/core';
import React from 'react';
import ContextMenuItem from './ContextMenuItem';
const useStyles = makeStyles((theme) => {
    return {
        contextMenuItemGroup: {
            '&:not(:empty)': {
                padding: `${theme.spacing(2)}px 0`
            },
            '& + &:not(:empty)': {
                borderTop: `1px solid ${theme.palette.ui04}`
            }
        }
    };
});
const ContextMenuItemGroup = ({ actions, children }) => {
    const styles = useStyles();
    return (React.createElement("div", { className: styles.contextMenuItemGroup },
        children, actions === null || actions === void 0 ? void 0 :
        actions.map(actionProps => (React.createElement(ContextMenuItem, Object.assign({ key: actionProps.text }, actionProps))))));
};
export default ContextMenuItemGroup;
